/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Bucket_NameInputs */

const en_admin_settings_fields_r2_bucket_name = /** @type {(inputs: Admin_Settings_Fields_R2_Bucket_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bucket Name`)
};

const zh_admin_settings_fields_r2_bucket_name = /** @type {(inputs: Admin_Settings_Fields_R2_Bucket_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储桶名称`)
};

/**
* | output |
* | --- |
* | "Bucket Name" |
*
* @param {Admin_Settings_Fields_R2_Bucket_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_bucket_name = /** @type {((inputs?: Admin_Settings_Fields_R2_Bucket_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Bucket_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_bucket_name(inputs)
	return zh_admin_settings_fields_r2_bucket_name(inputs)
});
export { admin_settings_fields_r2_bucket_name as "admin.settings.fields.r2_bucket_name" }